import * as React from 'react'
import PropTypes from 'prop-types'
import { default as MuiTabs } from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { parseAsInteger, useQueryState } from 'nuqs'

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <Box
      sx={{ mt: 2 }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ overflow: 'auto' }}>{children}</Box>}
    </Box>
  )
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

export default function Tabs({ tabsConfig }) {
  const [value, setValue] = useQueryState(
    'activeTab',
    parseAsInteger.withDefault(0)
  )

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <MuiTabs
        value={value}
        onChange={handleChange}
        aria-label="tabs"
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        {tabsConfig.map((tab) => (
          <Tab
            key={tab.id}
            label={tab.label}
            value={tab.id}
            {...a11yProps(tab.id)}
            defaultChecked={tab.id === tabsConfig[0].id}
          />
        ))}
      </MuiTabs>
      {tabsConfig.map((tab) => (
        <CustomTabPanel key={tab.id} value={value} index={tab.id}>
          {tab.content}
        </CustomTabPanel>
      ))}
    </Box>
  )
}
